const getIconName = (type) => {
  if (type === 'Kickoff') {
    return 'icon-announcement';
  }
  if (type === 'Pass_success') {
    return 'icon-info';
  }
  if (['Goal', 'Free_kick_hit', 'Goal_with_assist', 'Penalty_successful'].includes(type)) {
    return 'icon-ball-green';
  } else if(['Penalty_missed'].includes(type)){
    return 'icon-ball-red';
  }
  return 'icon-announcement';
}

const getHighlightsIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red') {
    return '<i class="icon-red-card"></i>';
  }
  if (['Goal', 'Goal_with_assist', 'Free_kick_hit', 'Penalty_successful', 'Penalty_missed'].includes(type)) {
    return goals;
  }
  return type;
}

const getHighlightsOnlyIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<span class="pointer"></span><i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red' || type === 'Card_yellow_red') {
      return '<span class="pointer"></span><i class="icon-red-card"></i>';
  }
  if (['Goal', 'Free_kick_hit', 'Penalty_successful', 'Goal_with_assist'].includes(type)) {
      return '<span class="pointer"></span><i class="icon-ball-green"></i>';
  }
  return type;
}

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export default ({ report, stats, highlights, data }) => (`
<div class="wide-container d-flex flex-column flex-lg-row">
    <div class="wide-container__column order-3 order-lg-1">
        <div class="card">
            <div class="card__heading">
                Timeline (${report[0]?.minute||0}’)
                <button class="js-audio-pause audio-pause">
                  <i class="icon-volume-mute2"></i>
                </button>
            </div>
            <div class="card__body card__body--overlay">
              ${report?.map((item, index) => `
                <div class="timeline js-timeline-item d-flex ${index === 0 ? 'new' : 'old'}" data-audio="${item.audio||''}">
                  <div class="timeline__type">
                      <i class="${getIconName(item.actiontype)}"></i>
                  </div>
                  <div class="timeline__content d-flex flex-column">
                      <div class="timeline__title">
                          ${item.action_name} ${['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(item.actiontype) ? `(${item.goals})` : ''}
                      </div>
                      <div class="timeline__description">
                          ${item.message}
                      </div>
                      <div class="timeline__date">
                          ${item.minute}’
                      </div>
                  </div>
              </div>
              `).join('')}
            </div>
        </div>
    </div>
    <div class="wide-container__middle order-1 order-lg-2">
        <div class="card">
            <div class="card__heading">
                Info
            </div>
            <div class="card__body card__body--info">
                <div class="match-info">
                    <div class="match-info__score d-flex align-items-center justify-content-center">
                        <div class="match-info__score-team d-flex flex-column"><div class="match-info__logo"><img class="match-info__logo-image" src="/assets/images/logo2.svg" alt="" /></div> ${data.home_name}</div>
                        <div class="match-info__score-result text-center d-flex align-items-center justify-content-center">${stats?.Goals ? stats?.Goals[1]||0 : '0'} : ${stats?.Goals ? stats?.Goals[2]||0 : '0'}</div>
                        <div class="match-info__score-team d-flex flex-column"><div class="match-info__logo"><img class="match-info__logo-image" src="/assets/images/logo4.svg" alt="" /></div>
                        ${data?.guest_name || (`
                          <button type="button" class="js-join-match default-button" data-id="${data?.id}" data-seo="/${data?.seo}" data-type="${data?.type}" data-price="${data?.price}">
                            <span class="default-button__text">Join</span>
                          </button>
                        `)}
                        </div>
                    </div>
                    <div class="match-info__lines">
                      <div class="match-info__lines-45">
                        ${highlights?.filter((item) => Number(item.minute) <= 45)?.map((item) => `
                          <div class="match-info__line" style="left: ${item.minute * 2}%;">
                            ${getHighlightsOnlyIcon(item.actiontype)}
                          </div>
                        `).join('')}
                      </div>
                      <div class="match-info__lines-45">
                        ${highlights?.filter((item) => Number(item.minute) > 45)?.map((item) => `
                          <div class="match-info__line" style="left: ${(item.minute - 45) * 2}%;">
                            ${getHighlightsOnlyIcon(item.actiontype)}
                          </div>
                        `).join('')}
                      </div>
                    </div>
                </div>
            </div>
            ${data?.reward ? `<div class="card__footer"><p>Reward: ${data.reward} $${data.wallet_type}</p></div>` : ""}
        </div>
        <div class="card d-lg-block">
            <div class="card__heading">
                Lineups
            </div>
            <div class="card__body p-3">
                <div class="lineups">
                    <img src="/assets/images/stat.jpeg" class="lineups__stat m-0 d-flex" alt="" />
                    <div class="home">
                        ${[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]?.map((item) => `
                          <div class="lineups__player lineups__player--a" data-number="${item}">
                              <span class="icon-team-a" style="font-size: 40px;"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                              <span class="lineups__player-number">${item}</span>
                          </div>
                        `).join('')}
                    </div>

                    <div class="guest">
                        ${[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]?.map((item) => `
                          <div class="lineups__player lineups__player--b" data-number="${item}">
                              <span class="icon-team-b" style="font-size: 40px;"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                              <span class="lineups__player-number">${item}</span>
                          </div>
                        `).join('')}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="wide-container__column order-2 order-lg-3">
        <div class="card">
            <div class="card__heading">
                Stats
            </div>
            <div class="card__body">
                <div class="stat-info">
                    <div class="stat-info__score d-flex align-items-center justify-content-center">
                        <div class="stat-info__score-team d-flex flex-column"><div class="stat-info__logo"><img class="match-info__logo-image" src="/assets/images/logo2.svg" alt="" /></div> ${data.home_name}</div>
                        <div class="stat-info__score-result text-center d-flex align-items-center justify-content-center">Team Stats</div>
                        <div class="stat-info__score-team d-flex flex-column"><div class="stat-info__logo"><img class="match-info__logo-image" src="/assets/images/logo4.svg" alt="" /></div> ${data.guest_name}</div>
                    </div>
                </div>
                ${(Object.keys(stats))?.map((item) => `
                  <div class="stat-item d-flex align-items-center justify-content-center">
                      <div class="col stat-item__value text-center">${stats[item][1]||0}</div>
                      <div class="col stat-item__title text-center" style=" text-transform: capitalize">${item.replace('_', ' ').replace('_', ' ').toLowerCase()}</div>
                      <div class="col stat-item__value text-center">${stats[item][2]||0}</div>
                  </div>
                `).join('')}
            </div>
        </div>
        ${highlights.length > 0 ? (`
          <div class="card">
            <div class="card__heading">
                Highlights
            </div>
            <div class="card__body">
              ${highlights?.map((item) => `
                <div class="highlight d-flex align-items-center">
                  <div class="highlight__type">
                    <div class="highlight__content">
                      ${getHighlightsIcon(item.actiontype, item.goals)}
                    </div>
                  </div>
                  <div class="highlight__title">${item.action_name}</div>
                  <div class="highlight__date ml-auto">${item.minute}’</div>
                </div>
              `).join('')}
            </div>
          </div>
        `) : ''}
    </div>
</div>
`);
